import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

const HEX_CHARACTERS = /(^[0-9A-F]$)/i;

@Component({
  selector: 'mode-hex-input',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './hex-input.component.html',
  styleUrls: ['./hex-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HexInputComponent {
  @Input() currentColor = '';
  @Output() hexUpdated = new EventEmitter<string>();

  onInputChange(event: InputEvent) {
    this.validateHex((event.target as HTMLInputElement)?.value);
  }

  onInputBlur(event: InputEvent) {
    const hexInput = (event.target as HTMLInputElement)?.value;
    this.validateHex(hexInput, false);
  }

  validateInput(event: KeyboardEvent) {
    // only allow user to input backspace, arrow keys, and valid hex characters
    if (
      event.key === 'ArrowRight' ||
      event.key === 'ArrowLeft' ||
      event.key === 'ArrowUp' ||
      event.key === 'ArrowDown'
    ) {
      return true;
    }

    if (event.key === 'Enter') {
      const hexInput = (event.target as HTMLInputElement)?.value;
      this.validateHex(hexInput, false);
    }

    if (HEX_CHARACTERS.test(event.key)) {
      return true;
    }

    return false;
  }

  isHex(hex: string) {
    return !isNaN(Number(`0x${hex}`));
  }

  validateHex(hex: string | undefined, longHex = true) {
    const hexLength = longHex ? 6 : 3;
    if (hex != null && hex.length === hexLength && this.isHex(hex)) {
      this.hexUpdated.emit(hex);
      this.currentColor = hex;
    }
  }
}
